import { createSelector } from 'reselect';
import { AppState } from '../reducers';
import { ProductsState } from '../reducers/products.reducers';

export const getProductsState = (state: AppState) =>
  state.products || ({} as ProductsState);

export const getProducts = createSelector(getProductsState, (productsState) => productsState.products);

export const isLoadingProducts = createSelector(getProductsState, (productsState) => productsState.loading);
